import './app.css';

import './scripts/mobile-menu';
import './scripts/desktop-menu';
import './scripts/header';
import './scripts/form';
import './scripts/fetch-posts';
